// extracted by mini-css-extract-plugin
export var arrow = "ProjectCategoryCard-module--arrow--c7203";
export var categoryTile = "ProjectCategoryCard-module--categoryTile--e9d44";
export var categoryTileImage = "ProjectCategoryCard-module--categoryTileImage--7dc8b";